export default "__VITE_ASSET__CHQXQldv__"